import { render, staticRenderFns } from "./CheckboxCategories.vue?vue&type=template&id=11143156"
import script from "./CheckboxCategories.vue?vue&type=script&lang=js"
export * from "./CheckboxCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports